import { ResourcesAdjustmentShape, ResourcesRecordShape } from '../../api/api_data_types'

function normalizeTerm(value: string | null | undefined): string {
  return (value || '').trim().toLowerCase()
}

function matchFields(fields: Array<string | null | undefined>, term: string): boolean {
  return fields.some((field) => normalizeTerm(field).includes(term))
}

function jobnumberFields(jobnumber?: ResourcesRecordShape['jobnumber'] | ResourcesAdjustmentShape['jobnumber']) {
  if (!jobnumber) {
    return []
  }

  return [
    jobnumber.job_id,
    jobnumber.job_id_title,
    jobnumber.order_number,
    jobnumber.order_number_title,
    jobnumber.order_or_quote_number,
    jobnumber.customer_title,
    jobnumber.full_title,
    jobnumber.title,
    jobnumber.jobnumber,
  ]
}

function commentFields(times: Array<{ comment: string }>): string[] {
  return times.map((time) => time.comment)
}

export function recordMatchesFilter(record: ResourcesRecordShape, term: string): boolean {
  const normalizedTerm = normalizeTerm(term)

  if (!normalizedTerm) {
    return true
  }

  return matchFields([...jobnumberFields(record.jobnumber), ...commentFields(record.times)], normalizedTerm)
}

export function absenceMatchesFilter(record: ResourcesRecordShape, term: string): boolean {
  return recordMatchesFilter(record, term)
}

export function adjustmentMatchesFilter(adjustment: ResourcesAdjustmentShape, term: string): boolean {
  const normalizedTerm = normalizeTerm(term)

  if (!normalizedTerm) {
    return true
  }

  return matchFields([...jobnumberFields(adjustment.jobnumber), ...commentFields(adjustment.times)], normalizedTerm)
}
